import {Element} from "@api/models/Element";
import {DateTime} from "luxon";
import { dateInOriginalOffset, zoneNameByOffset} from "../../../common/dateTimeHelper";

const chooseDateFromSet = (dates: Array<string>, offset: number): DateTime => {
    const today = dateInOriginalOffset(DateTime.local(), offset).startOf('day');

    for (let index in dates) {
        const dateInstance = DateTime.fromFormat(dates[index], "d.MM.yyyy", { zone: zoneNameByOffset(offset) }).startOf('day');
        if (dateInstance >= today) {
            return dateInstance;
        }
    }

    return DateTime.fromFormat(dates[dates.length - 1], "d.MM.yyyy", { zone: zoneNameByOffset(offset) });
}

export const chooseInitDate = (event: Element, offset: number, dates: Array<string> | null): DateTime => {

    if (dates?.length) {
        return chooseDateFromSet(dates, offset);
    }

    let date: DateTime = dateInOriginalOffset(DateTime.local(), offset);
    const beginAt = event?.beginAt ? dateInOriginalOffset(event.beginAt, offset) : null;
    if (beginAt) {
        const end: DateTime = dateInOriginalOffset(event.endAt || DateTime.fromISO('2900-01-01'), offset).endOf('day');
        if (!(beginAt.startOf('day') <= date && date <= end)) {
            date = event.beginAt;
        }
    }
    return date;
}
